export const SERVER_URL = '//journeymaker.cincyart.org/'
export const ACCOUNT_ID = 'artmuseum'
export const PRINT_SERVER = 'http://localhost:5000'
export const FORCE_ASSET_HTTPS = true


// WEBPACK FOOTER //
// ./src/config.js